

export const getCurrentDateISO = () => new Date().toISOString().split('T')[0];
export const getCurrentDateISOWithTime = () => new Date().toISOString();
export const convertDateToISO = date => new Date(date).toISOString().split('T')[0];
export function convertLocalDateToISOWithOffset(dateStr) {
  const date = new Date(dateStr);
  const isLastDayOfYear = (date.getMonth() === 12 && date.getDate() === 31);
  if (isLastDayOfYear) {
    date.setHours(23, 59, 59, 0);
  } else {
    date.setHours(0, 0, 0, 0);
  }
  // Get the timezone offset from the user's local time zone
  const offset = date.getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(offset) / 60);
  const offsetMinutes = Math.abs(offset) % 60;
  const offsetSign = offset > 0 ? '-' : '+';
  // eslint-disable-next-line max-len
  const offsetString = `${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
  const offsetDate = new Date(date.getTime() - offset * 60 * 1000);
  // eslint-disable-next-line max-len
  const isoString = `${offsetDate.toISOString().split('T')[0]}T${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}${offsetString}`;
  return isoString;
}
export function convertUTCToLocal(utcDateStr) {
   // Parse the UTC date string into a Date object
   const utcDate = new Date(utcDateStr);
   // Convert to local time zone
   const localDateStr = utcDate.toLocaleString('en-US', {
     timeZoneName: 'short',
     hour12: false
   });
   // Reformat the date to ISO 8601 format with local time zone offset
   const localDate = new Date(localDateStr);
   // Get the local timezone offset
   const offset = localDate.getTimezoneOffset();
   const offsetHours = Math.floor(Math.abs(offset) / 60);
   const offsetMinutes = Math.abs(offset) % 60;
   const offsetSign = offset > 0 ? '-' : '+';
   // eslint-disable-next-line max-len
   const offsetString = `${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
   // Format the local date to 'YYYY-MM-DDTHH:MM:SS' format
   const year = localDate.getFullYear();
   const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Month is 0-based
   const day = String(localDate.getDate()).padStart(2, '0');
   const hour = String(localDate.getHours()).padStart(2, '0');
   const minute = String(localDate.getMinutes()).padStart(2, '0');
   const second = String(localDate.getSeconds()).padStart(2, '0');
   
   const formattedDate = `${year}-${month}-${day}T${hour}:${minute}:${second}${offsetString}`;
   return formattedDate;
 }

 export function getStartDate(days) {
  const now = new Date();
  now.setDate(now.getDate() - days); // subtract the days
  now.setHours(0, 0, 0, 0); // set time to 00:00:00

  // Format the date as ISO string with local timezone offset
  const timezoneOffset = -now.getTimezoneOffset(); // in minutes
  const offsetHours = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
  const offsetMinutes = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');
  const offsetSign = timezoneOffset >= 0 ? '+' : '-';
  const localOffset = `${offsetSign}${offsetHours}:${offsetMinutes}`;

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const date = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${date}T${hours}:${minutes}:${seconds}${localOffset}`;
}